export enum ImpactTypeEnum {
  /**
   * plant trees
   */
  trees = "trees",

  /**
   * invest in renewable energies
   */
  renewable = "renewable",

  /**
   * invest in renewable charging infrastructure
   */
  charging = "charging",

  /**
   * payout
   */
  payout = "payout",

  /**
   * Load credits to customer account
   */
  customerAccount = "customerAccount"
}
